export {
  DotLoader,
  DotLoaderProps,
  DotLoaderStylesKey,
  DotLoaderClasses,
} from './DotLoader';
